import { render, staticRenderFns } from "./AddCustomerOwnerDrawer.vue?vue&type=template&id=474bb064&"
import script from "./AddCustomerOwnerDrawer.vue?vue&type=script&lang=js&"
export * from "./AddCustomerOwnerDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports